import interceptorAxios from './InterceptorAxios';
const ServicioTcCliente={
    guardar(objeto){
        return interceptorAxios.post('/cliente/guardar.json',objeto);
    },
    eliminar(objeto){
        return interceptorAxios.post('/cliente/eliminar.json',objeto);
    },
    paginacion(objeto){
        return interceptorAxios.post('/cliente/paginacion.json',objeto);
    },
    editar_cliente(objeto){
        return interceptorAxios.post('/cliente/actualizar_informacion.json',objeto);
    },
    editar_logo(objeto){
        return interceptorAxios.post('/cliente/actualizar_logo.json',objeto);
    },
    editar_color(objeto){
        return interceptorAxios.post('/cliente/actualizar_color.json',objeto);
    },
    editar_encabezado(objeto){
        return interceptorAxios.post('/cliente/actualizar_diseno.json',objeto);
    }
}
export default ServicioTcCliente;